import { isNil, omitBy } from "lodash";
import UAParser from "ua-parser-js";

import fetchDoc from "util/api/fetchDoc";

const removeNil = (obj) => omitBy(obj, isNil);

const getCustomerByCustomerUid = (businessUid, customerUid) => {
  return fetchDoc(`business-customers/business/${businessUid}/${customerUid}`);
};

function getUserAgent() {
  if (typeof navigator !== "undefined" && navigator.userAgent) {
    return navigator.userAgent;
  } else {
    return null;
  }
}

async function getLocationData() {
  const locationData = localStorage.getItem("locationData");
  if (locationData) return JSON.parse(locationData);

  try {
    const response = await fetch("https://ipinfo.io/json?token=2dfea51eff7728");
    const data = await response.json();
    localStorage.setItem("locationData", JSON.stringify(data));
    return JSON.parse(data);
  } catch (error) {
    console.error("Error fetching location data: ", error);
  }
}

function getUserAgentInfo() {
  const userAgent = getUserAgent();
  if (!userAgent) return null;

  const parser = new UAParser(userAgent);
  const browser = removeNil(parser.getBrowser());
  const cpu = removeNil(parser.getCPU());
  const device = removeNil(parser.getDevice());
  const engine = removeNil(parser.getEngine());
  const os = removeNil(parser.getOS());
  const ua = parser.getUA();

  return {
    browser,
    cpu,
    device,
    engine,
    os,
    ua,
  };
}

const createCustomerData = (customer) => {
  if (!customer) return null;
  const { name, email } = customer;
  return {
    ...(name && { name }),
    ...(email && { email }),
    ...(customer.phoneNumber && { phoneNumber: customer.phoneNumber }),
    ...(customer.phone && { phoneNumber: customer.phone }),
  };
};

export default async function fetchCustomerLocationData(
  businessUid,
  customerUid
) {
  const url = window.location.href;
  let customer = JSON.parse(localStorage.getItem("resto-guru-customer"));

  if (!customer?.name && !customer?.email && !customer?.phone) customer = null;
  if (!customer) {
    customer = await getCustomerByCustomerUid(businessUid, customerUid);
  }

  const userAgent = getUserAgentInfo();
  const location = await getLocationData();
  return {
    createdAt: new Date(),
    customer: createCustomerData(customer),
    ...(location && { location }),
    url,
    userAgent,
  };
}
